import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// Auto-recover from stale Vite chunk 404s after new deployments
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason?.message || String(event.reason || '');
  if (
    reason.includes('Failed to fetch dynamically imported module') ||
    reason.includes('Importing a module script failed') ||
    reason.includes('error loading dynamically imported module')
  ) {
    const key = 'vite_chunk_reload_attempts';
    const attempts = Number(sessionStorage.getItem(key) || 0);
    if (attempts < 2) {
      sessionStorage.setItem(key, String(attempts + 1));
      window.location.reload();
    }
  }
});

window.addEventListener('load', () => {
  sessionStorage.removeItem('vite_chunk_reload_attempts');
});

// Dynamic API redirection (uses relative paths for production to retain main SSL certificate)
const getBackendBaseUrl = () => {
  return ''; // Resolves via local proxy in dev, and relative domain in production
};

const originalFetch = window.fetch;
window.fetch = function (input, init) {
  let url = typeof input === 'string' ? input : input.url;
  
  if (url.startsWith('/api/')) {
    const baseUrl = getBackendBaseUrl();
    const newUrl = baseUrl + url;
    if (typeof input === 'string') {
      input = newUrl;
    } else {
      input = new Request(newUrl, input);
    }
  }
  return originalFetch(input, init);
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
